import { toast } from 'react-toastify';
import { Api } from '../lib/api/api';

export const getFaxes = token => async dispatch => {
  dispatch({
    type: 'GET_FAXES',
  });
  dispatch(getIncomingFaxes(token));
  dispatch(getOutgoingFaxes(token, undefined, undefined, true));
  dispatch(getOutgoingFaxes(token, undefined, undefined, false));
};

export const getIncomingFaxes = (token, paginateOptions, dateFilter) => async dispatch => {
  const api = new Api(token);
  dispatch({
    type: 'INCOMING_FAXES',
  });
  try {
    const incomingFaxes = await api.faxes.getIncomingFaxes(paginateOptions, dateFilter);
    dispatch({
      type: 'INCOMING_FAXES_SUCCESS',
      incomingFaxes,
    });
  } catch (error) {
    dispatch({
      type: 'INCOMING_FAXES_ERROR',
      error,
    });
  }
};

export const getOutgoingFaxesFilter = (
  token,
  companyId,
  paginateOptions,
  date,
  relay,
) => async dispatch => {
  const api = new Api(token);
  dispatch({
    type: 'OUTGOING_FAXES',
  });
  try {
    const outgoingFaxes = await api.faxes.getOutgoingFaxesFilter(
      companyId,
      paginateOptions,
      date,
      relay,
    );
    if (relay) {
      dispatch({
        type: 'RELAY_FAXES_SUCCESS',
        outgoingFaxes,
      });
    } else {
      dispatch({
        type: 'OUTGOING_FAXES_SUCCESS',
        outgoingFaxes,
      });
    }
  } catch (error) {
    if (relay) {
      dispatch({
        type: 'RELAY_FAXES_ERROR',
        error,
      });
    } else {
      dispatch({
        type: 'OUTGOING_FAXES_ERROR',
        error,
      });
    }
  }
};

export const getFaxesSummaryByCompany = (token, id, date) => async dispatch => {
  const api = new Api(token);
  try {
    const faxesSummary = await api.faxes.getFaxesSummaryByCompany(id, date);
    dispatch({
      type: 'FAXES_SUMMARY_SUCCESS',
      faxesSummary,
    });
  } catch (error) {
    dispatch({
      type: 'FAXES_SUMMARY_ERROR',
      error,
    });
  }
};

export const getFaxesSummaryByUser = (token, id, date) => async dispatch => {
  const api = new Api(token);
  try {
    const faxesSummary = await api.faxes.getFaxesSummaryByUser(id, date);
    dispatch({
      type: 'FAXES_SUMMARY_SUCCESS',
      faxesSummary,
    });
  } catch (error) {
    dispatch({
      type: 'FAXES_SUMMARY_ERROR',
      error,
    });
  }
};

export const faxNumberFilterSummary = (token, number, type, date) => async dispatch => {
  const api = new Api(token);
  // toast.success('Fetching Data, Please Wait...');
  try {
    const faxesSummary = await api.faxes.faxNumberFilterSummary(number, type, date);
    dispatch({
      type: 'FAXES_SUMMARY_SUCCESS',
      faxesSummary,
    });
  } catch (error) {
    dispatch({
      type: 'FAXES_SUMMARY_ERROR',
      error,
    });
  }
};

export const getFaxesSummary = (token, date = ['', '']) => async dispatch => {
  const api = new Api(token);
  try {
    const faxesSummary = await api.faxes.getFaxesSummary(date);
    dispatch({
      type: 'FAXES_SUMMARY_SUCCESS',
      faxesSummary,
    });
  } catch (error) {
    dispatch({
      type: 'FAXES_SUMMARY_ERROR',
      error,
    });
  }
};

export const getFaxesFailureSummaryByCompany = (token, id, date) => async dispatch => {
  const api = new Api(token);
  try {
    const faxesFailureSummary = await api.faxes.getFaxesFailureSummaryByCompany(id, date);
    dispatch({
      type: 'FAXES_FAILURE_SUMMARY_SUCCESS',
      faxesFailureSummary,
    });
  } catch (error) {
    dispatch({
      type: 'FAXES_FAILURE_SUMMARY_ERROR',
      error,
    });
  }
};

export const getFaxesFailureSummaryByUser = (token, id, date) => async dispatch => {
  const api = new Api(token);
  try {
    const faxesFailureSummary = await api.faxes.getFaxesFailureSummaryByUser(id, date);
    dispatch({
      type: 'FAXES_FAILURE_SUMMARY_SUCCESS',
      faxesFailureSummary,
    });
  } catch (error) {
    dispatch({
      type: 'FAXES_FAILURE_SUMMARY_ERROR',
      error,
    });
  }
};

export const faxNumberFilterFailureSummary = (token, number, type, date) => async dispatch => {
  const api = new Api(token);
  try {
    const faxesFailureSummary = await api.faxes.faxNumberFilterFailureSummary(number, type, date);
    dispatch({
      type: 'FAXES_FAILURE_SUMMARY_SUCCESS',
      faxesFailureSummary,
    });
  } catch (error) {
    dispatch({
      type: 'FAXES_FAILURE_SUMMARY_ERROR',
      error,
    });
  }
};

export const getFaxesFailureSummary = (token, date = ['', '']) => async dispatch => {
  const api = new Api(token);
  try {
    const faxesFailureSummary = await api.faxes.getFaxesFailureSummary(date);
    dispatch({
      type: 'FAXES_FAILURE_SUMMARY_SUCCESS',
      faxesFailureSummary,
    });
  } catch (error) {
    dispatch({
      type: 'FAXES_FAILURE_SUMMARY_ERROR',
      error,
    });
  }
};

export const getIncomingFaxesByUser = (token, userID, paginateOptions, date) => async dispatch => {
  const api = new Api(token);
  dispatch({
    type: 'INCOMING_FAXES',
  });
  try {
    const incomingFaxes = await api.faxes.getIncomingFaxesByUser(userID, paginateOptions, date);
    dispatch({
      type: 'INCOMING_FAXES_SUCCESS',
      incomingFaxes,
    });
  } catch (error) {
    dispatch({
      type: 'INCOMING_FAXES_ERROR',
      error,
    });
  }
};

export const getOutgoingFaxesByUser = (
  token,
  userID,
  paginateOptions,
  date,
  relay,
) => async dispatch => {
  const api = new Api(token);
  dispatch({
    type: 'OUTGOING_FAXES',
  });
  try {
    const outgoingFaxes = await api.faxes.getOutgoingFaxesByUser(
      userID,
      paginateOptions,
      date,
      relay,
    );
    if (relay) {
      dispatch({
        type: 'RELAY_FAXES_SUCCESS',
        outgoingFaxes,
      });
    } else {
      dispatch({
        type: 'OUTGOING_FAXES_SUCCESS',
        outgoingFaxes,
      });
    }
  } catch (error) {
    if (relay) {
      dispatch({
        type: 'RELAY_FAXES_ERROR',
        error,
      });
    } else {
      dispatch({
        type: 'OUTGOING_FAXES_ERROR',
        error,
      });
    }
  }
};

export const getIncomingFaxesFilter = (
  token,
  companyId,
  paginateOptions,
  date,
) => async dispatch => {
  const api = new Api(token);
  dispatch({
    type: 'INCOMING_FAXES',
  });
  try {
    const incomingFaxes = await api.faxes.getIncomingFaxesFilter(companyId, paginateOptions, date);
    dispatch({
      type: 'INCOMING_FAXES_SUCCESS',
      incomingFaxes,
    });
  } catch (error) {
    dispatch({
      type: 'INCOMING_FAXES_ERROR',
      error,
    });
  }
};

export const incomingfaxFilterByNumber = (
  token,
  type,
  value,
  date,
  paginateOptions,
) => async dispatch => {
  const api = new Api(token);
  dispatch({
    type: 'INCOMING_FAXES',
  });
  try {
    const incomingFaxes = await api.faxes.incomingfaxFilterByNumber(
      type,
      value,
      date,
      paginateOptions,
    );
    dispatch({
      type: 'INCOMING_FAXES_SUCCESS',
      incomingFaxes,
    });
  } catch (error) {
    dispatch({
      type: 'INCOMING_FAXES_ERROR',
      error,
    });
  }
};

export const outgoingfaxFilterByNumber = (
  token,
  type,
  value,
  date,
  paginateOptions,
  relay,
) => async dispatch => {
  const api = new Api(token);
  dispatch({
    type: 'OUTGOING_FAXES',
  });
  try {
    const outgoingFaxes = await api.faxes.outgoingfaxFilterByNumber(
      type,
      value,
      date,
      paginateOptions,
      relay,
    );
    if (relay) {
      dispatch({
        type: 'RELAY_FAXES_SUCCESS',
        outgoingFaxes,
      });
    } else {
      dispatch({
        type: 'OUTGOING_FAXES_SUCCESS',
        outgoingFaxes,
      });
    }
  } catch (error) {
    if (relay) {
      dispatch({
        type: 'RELAY_FAXES_ERROR',
        error,
      });
    } else {
      dispatch({
        type: 'OUTGOING_FAXES_ERROR',
        error,
      });
    }
  }
};

export const getOutgoingFaxes = (token, paginateOptions, dateFilter, relay) => async dispatch => {
  const api = new Api(token);
  dispatch({
    type: 'OUTGOING_FAXES',
  });
  try {
    const outgoingFaxes = await api.faxes.getOutgoingFaxes(paginateOptions, dateFilter, relay);
    if (relay) {
      dispatch({
        type: 'RELAY_FAXES_SUCCESS',
        outgoingFaxes,
      });
    } else {
      dispatch({
        type: 'OUTGOING_FAXES_SUCCESS',
        outgoingFaxes,
      });
    }
  } catch (error) {
    if (relay) {
      dispatch({
        type: 'RELAY_FAXES_ERROR',
        error,
      });
    } else {
      dispatch({
        type: 'OUTGOING_FAXES_ERROR',
        error,
      });
    }
  }
};

export const deleteFaxShow = id => dispatch => {
  dispatch({
    type: 'DELETE_FAX_SHOW',
    id,
  });
};

export const deleteFaxCancel = () => dispatch => {
  dispatch({
    type: 'DELETE_FAX_CANCEL',
  });
};

export const onRecoverIncomingFax = (token, faxId) => async dispatch => {
  const api = new Api(token);
  dispatch({
    type: 'RECOVER_INCOMING_FAX',
  });
  try {
    await api.faxes.onRecoverIncomingFax(faxId);
    dispatch({
      type: 'RECOVER_INCOMING_FAX_SUCCESS',
    });
    toast.success('Fax Recovered Successfully!');
    return true;
  } catch (error) {
    dispatch({
      type: 'RECOVER_INCOMING_FAX_FAILURE',
      error,
    });
    toast.error(error.response.data || `Error in recovering Fax`);
  }
};

export const onRecoverOutgoingFax = (token, faxId) => async dispatch => {
  const api = new Api(token);
  dispatch({
    type: 'RECOVER_OUTGOING_FAX',
  });
  try {
    await api.faxes.onRecoverOutgoingFax(faxId);
    dispatch({
      type: 'RECOVER_OUTGOING_FAX_SUCCESS',
    });
    toast.success('Fax Recovered Successfully!');
    return true;
  } catch (error) {
    dispatch({
      type: 'RECOVER_OUTGOING_FAX_FAILURE',
      error,
    });
    toast.error(error.response.data || `Error in recovering Fax`);
  }
};

export const onCancelFax = (token, faxId) => async dispatch => {
  const api = new Api(token);
  dispatch({
    type: 'ON_CANCEL_FAX',
  });
  try {
    await api.faxes.onCancelFax(faxId);
    dispatch({
      type: 'ON_CANCEL_FAX_SUCCESS',
    });
    toast.success('Fax Cancelled');
    return true;
  } catch (error) {
    dispatch({
      type: 'ON_CANCEL_FAX_FAILURE',
      error,
    });
    toast.error(error.response.data || `Error in cancelling Fax`);
  }
};

export const onResendFax = (token, faxId, relay) => async dispatch => {
  const api = new Api(token);
  dispatch({
    type: 'ON_RESEND_FAX',
  });
  try {
    await api.faxes.onResendFax(faxId, relay);
    dispatch({
      type: 'ON_RESEND_FAX_SUCCESS',
    });
    toast.success('Fax Resent');
    return true;
  } catch (error) {
    dispatch({
      type: 'ON_RESEND_FAX_FAILURE',
      error,
    });
    toast.error(error.response.data || `Error in cancelling Fax`);
  }
};

export const deleteOutgoingFax = (token, id) => async dispatch => {
  const api = new Api(token);
  dispatch({
    type: 'DELETE_FAX',
    id,
  });
  try {
    await api.faxes.deleteOutgoingFax(id);
    dispatch({
      type: 'DELETE_FAX_SUCCESS',
    });
    toast.success('Fax Deleted Successfully!');
    return true;
  } catch (error) {
    dispatch({
      type: 'DELETE_FAX_ERROR',
      error,
    });
    toast.error(error.response.data || 'Error Deleting Fax');
  }
};

export const deleteIncomingFax = (token, id) => async dispatch => {
  const api = new Api(token);
  dispatch({
    type: 'DELETE_FAX',
    id,
  });
  try {
    await api.faxes.deleteIncomingFax(id);
    dispatch({
      type: 'DELETE_FAX_SUCCESS',
    });
    toast.success('Fax Deleted Successfully!');
    return true;
  } catch (error) {
    dispatch({
      type: 'DELETE_FAX_ERROR',
      error,
    });
    toast.error(error.response.data || 'Error Deleting Fax');
  }
};

export const getAllPendingFaxes = (token, query) => async dispatch => {
  const api = new Api(token);
  dispatch({
    type: 'GET_ALL_PENDING_FAXES',
  });
  try {
    const data = await api.faxes.getAllPendingFaxesApi(query);
    dispatch({
      type: 'GET_ALL_PENDING_FAXES_SUCCESS',
    });
    return data;
  } catch (error) {
    dispatch({
      type: 'GET_ALL_PENDING_FAXES_ERROR',
      error,
    });
    toast.error(error?.response?.data || 'Error Getting Fax');
  }
};
export const deleteFaxAction = (token, uuid, dataCenter) => async dispatch => {
  const api = new Api(token);
  dispatch({
    type: 'DELETE_PENDING_FAXES',
  });
  try {
    const data = await api.faxes.deleteFaxApi(uuid, dataCenter);
    dispatch({
      type: 'DELETE_PENDING_FAXES_SUCCESS',
    });
    toast.success(data?.message || 'Fax is deleted')
    return data;
  } catch (error) {
    dispatch({
      type: 'DELETE_PENDING_FAXES_ERROR',
      error,
    });
    toast.error(error?.response?.data || 'Error Deleting Fax');
  }
};
export const getFaxesSummaryV2 = (token, query) => async dispatch => {
  const api = new Api(token);
  dispatch({
    type: 'FAX_SUMMARY_V2',
  });
  try {
    const data = await api.faxes.getFaxesSummaryV2Api(query);
    dispatch({
      type: 'FAX_SUMMARY_V2_SUCCESS',
    });
    return data;
  } catch (error) {
    dispatch({
      type: 'FAX_SUMMARY_V2_ERROR',
      error,
    });
    toast.error(error?.response?.data || 'Error Getting Fax');
  }
};
export const getFaxesFailSummaryV2 = (token, query) => async dispatch => {
  const api = new Api(token);
  dispatch({
    type: 'FAX_SUMMARY_V2',
  });
  try {
    const data = await api.faxes.getFaxesFailSummaryV2Api(query);
    dispatch({
      type: 'FAX_SUMMARY_V2_SUCCESS',
    });
    return data;
  } catch (error) {
    dispatch({
      type: 'FAX_SUMMARY_V2_ERROR',
      error,
    });
    toast.error(error?.response?.data || 'Error Getting Fax');
  }
};
export const getAllProcessedFaxes = (token, query) => async dispatch => {
  const api = new Api(token);
  dispatch({
    type: 'GET_ALL_PROCESSED_FAXES',
  });
  try {
    const data = await api.faxes.getAllProcessedFaxesApi(query);
    dispatch({
      type: 'GET_ALL_PROCESSED_FAXES_SUCCESS',
    });
    return data;
  } catch (error) {
    dispatch({
      type: 'GET_ALL_PROCESSED_FAXES_ERROR',
      error,
    });
    toast.error(error?.response?.data || 'Error Getting Fax');
  }
};

export const sendFaxShow = id => dispatch => {
  dispatch({
    type: 'SEND_FAX_SHOW',
    id,
  });
};

export const sendFaxCancel = () => dispatch => {
  dispatch({
    type: 'SEND_FAX_CANCEL',
  });
};

export const sendFax = (token, fax) => async dispatch => {
  const api = new Api(token);

  try {
    const { data } = await api.faxes.sendFax(fax);
    if (data.success) {
      dispatch({
        type: 'SEND_FAX_SUCCESS',
        fax: null,
      });
      toast.success('Fax is sent');
      return true;
    }

    dispatch({
      type: 'SEND_FAX_SHOW',
    });
    toast.error(data?.message || 'Error in Fax sending');
    return false;
  } catch (error) {
    toast.error(error?.response?.data || 'Error sending Fax');
    console.log('res is error', error?.response?.data)
    dispatch({
      type: 'SEND_FAX_SHOW',
    });
  }
};

export const numberSummary = (token, reportOf, type, date) => async () => {
  const api = new Api(token);
  await api.faxes.numberSummary(reportOf, type, date);
};

export const downloadFaxSummary = (token, date, type) => async () => {
  const api = new Api(token);
  await api.faxes.downloadFaxSummary(date, type);
};

export const downloadFaxSummaryByUser = (token, userID, date, type) => async () => {
  const api = new Api(token);
  await api.faxes.downloadFaxSummaryByUser(userID, date, type);
};

export const downloadFaxFailureSummaryByCompany = (token, userID, date, type) => async () => {
  const api = new Api(token);
  await api.faxes.downloadFaxFailureSummaryByCompany(userID, date, type);
};

export const downloadIncomingFax = (token, id, userID) => async dispatch => {
  const api = new Api(token);
  try {
    await api.faxes.downloadIncomingFax(id, userID);
  } catch (error) {
    toast.error(error.response.data || `Error in downloading Fax`);
  }
};

export const downloadOutgoingFax = (token, id, userID) => async dispatch => {
  const api = new Api(token);
  dispatch({
    type: 'DOWNLOAD_FAX',
    id,
    userID,
  });
  try {
    await api.faxes.downloadOutgoingFax(id, userID);
  } catch (error) {
    toast.error(error.response.data || `Error in downloading Fax`);
  }
};

// Send Fax Dialog
export const onSendFaxNumberChange = numbers => async dispatch => {
  dispatch({
    type: 'SEND_FAX_NUMBER_CHANGE',
    numbers,
  });
};

export const onSendFaxFilesChange = files => async dispatch => {
  dispatch({
    type: 'SEND_FAX_FILES_CHANGE',
    files,
  });
};

export const setActiveFaxTab = tab => dispatch => {
  dispatch({
    type: 'SET_ACTIVE_FAX_TAB',
    tab,
  });
};


export const checkPendingFaxes = (token, number) => async dispatch => {
  const api = new Api(token);
  dispatch({
    type: 'CHECK_PENDING_FAXES',
  });
  try {
    const data = await api.faxes.checkPendingFaxes(number);
    dispatch({
      type: 'CHECK_PENDING_FAXES_SUCCESS',
      data
    });
    return data;
  } catch (error) {
    dispatch({
      type: 'CHECK_PENDING_FAXES_ERROR',
      error,
    });
    toast.error(error?.response?.data || 'Error Getting Fax');
  }
};